import { render, staticRenderFns } from "./CardsSolutions.vue?vue&type=template&id=1562f322&scoped=true"
import script from "./CardsSolutions.js?vue&type=script&lang=js&external"
export * from "./CardsSolutions.js?vue&type=script&lang=js&external"
import style0 from "./CardsSolutions.scss?vue&type=style&index=0&id=1562f322&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1562f322",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default})
